export default "__VITE_ASSET__CmRknxlL__"